import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import AgentProfile from "./pages/management/AgentProfile/Index";
import ChangePassword from "./pages/Auth/ChangePassword";
import PromoCode from "./pages/customers/PromoCode/Index";
import PublicPromoCode from "./pages/customers/PublicPromoCode/Index";
import UsedPromoCodeByUser from "./pages/Report/UsedPromoCodeByUser/Index";
import SellReport from "./pages/Report/SellReport/Index";
import AgentWithdrawals from "./pages/wallet/AgentWithdrawals/Index";
import AgentAccount from "./pages/wallet/AgentAccount/Index";
import UserTransactions from "./pages/Report/UserTransactions/Index";
import KishPortInfo from "./pages/Services/KishPortInfo/Index";
import { CreateEditKishPortInfo } from "./pages/Services/KishPortInfo/CreateOrEdit";
import RechargeWallet from "./pages/wallet/RechargeWallet/Index";
import Tourism from "./pages/Tourism/Index";
import { PrintPromoCode } from "./pages/customers/QrCode/PrintPromoCode";
import Basket from "./pages/Basket/Index";
import Payment from "./pages/Basket/Payment";

import OrderConfirmation from "./pages/Basket/OrderConfirmation";
import AfterPayIndex from "./pages/wallet/RechargeWallet/AfterPay";
// import Concert from "./pages/Tourism/Concert";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {/* Redirect from root URL to /dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/agentProfile" element={<AgentProfile />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/promoCode" element={<PromoCode />} />
        <Route path="/publicPromoCode" element={<PublicPromoCode />} />
        <Route path="/usedPromoCodeByUser" element={<UsedPromoCodeByUser />} />
        <Route path="/sellReport" element={<SellReport />} />
        <Route path="/agentWithdrawals" element={<AgentWithdrawals />} />
        <Route path="/agentAccount" element={<AgentAccount />} />
        <Route path="/reportTransactions" element={<UserTransactions />} />
        <Route path="/rechargeWallet" element={<RechargeWallet />} />
        <Route path="/tourism" element={<Tourism />} />
        {/* <Route path="/concert" element={<Concert />} /> */}
        <Route path="/basket" element={<Basket />} />
        <Route path="/payment" element={<Payment />} />

        <Route path="/orderConfirmation" element={<OrderConfirmation />} />
        <Route path="/afterPay" element={<AfterPayIndex />} />
        <Route path="/kishPortInfo" element={<KishPortInfo />} />
        <Route path="/printPromoCode/:id" element={<PrintPromoCode />} />
        {/* <Route path="/ticket/:id" element={<Ticket />} /> */}
        <Route
          path="/createOrEditKishPortInfo/:id?"
          element={<CreateEditKishPortInfo />}
        />

        {/* Redirect to error page */}
        <Route path="*" element={<Navigate to="error/error-v1" replace />} />
      </Routes>
    </Suspense>
  );
}
